import React, { useEffect, useMemo, useState } from 'react';
import './Marquee.css';
import axios from 'axios';

const config = require("../../config.json");


const FlashNews = () => {
  /*const messages = [
    "🚀 Flash Sale: 50% off all courses!",
    "🛠️ New Update: React 19 support added.",
    "🌐 Join our global developer community.",
    "🎁 Referral rewards are now active!"
  ];*/
  const [activePost, setActivePost] = useState([]);
  const [tickerVersion, setTickerVersion] = useState(0);

  useEffect(() => {
    fetchFlashNews();

    const refreshInterval = setInterval(() => {
      fetchFlashNews();
    }, 60000);

    return () => clearInterval(refreshInterval);
  }, []);

  const fetchFlashNews = async () => {
    try {
      const startDate = await generateDate();
      const clientID = "ARCHIVE";
      const searchOption = "ActiveFlashNews";
      const searchFilter = "Active";

      const response = await axios.get(
        `${config.api.invokeURL}/dashboard/website/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}&searchFilter=${searchFilter}`,
        {
          headers: {
            'x-api-key': config.api.key
          }
        }
      );

      const normalizedPosts = Array.isArray(response.data) ? response.data : [];
      setActivePost(normalizedPosts);
      // Re-trigger CSS animation whenever fresh API data is received.
      setTickerVersion((prev) => prev + 1);
    } catch (error) {
      setActivePost([]);
      setTickerVersion((prev) => prev + 1);
    }
  };

      const generateDate = async () => {
        const current_datetime = new Date();
        const date_year = (current_datetime.getFullYear()).toString();
        var date_month = (current_datetime.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        var date_date = (current_datetime.getDate().toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var date_hours = (current_datetime.getHours().toString());
        var hours_value="";
        date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
        var date_minutes = (current_datetime.getMinutes().toString());
        var minutes_value="";
        date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
        var todayDate="";
        const tDate = todayDate.concat(date_year,"-",month_value,"-", date_value);
        //setUserId(accountNo);
        return tDate;
        //console.log("acc : ", accountNo);
    };

const tickerMessages = useMemo(() => {
  return activePost
    .map((item) => item?.flashNews?.message)
    .filter((message) => typeof message === 'string' && message.trim().length > 0);
}, [activePost]);

return (
  <div className="">
      <div className="news-ticker-container">
        
        {/* Fixed Label */}
        <div className="ticker-label">
          <span className="icon">📢</span>
          <span className="label-text">FLASH NEWS</span>
        </div>

        {/* Scrolling Area */}
        <div className="ticker-window">
          <div key={tickerVersion} className="ticker-track">
            {tickerMessages.map((message, i) => (
              <span key={i} className="ticker-item"><i className="fas fa-bullhorn me-2 "></i>{"  "}{message}</span>
            ))}
            {/* We repeat the array once to ensure no gap during the transition */}
            {tickerMessages.map((message, i) => (
              <span key={`dup-${i}`} className="ticker-item" aria-hidden="true"><i className="fas fa-bullhorn me-2 "></i>{"  "}{message}</span>
            ))}
            {tickerMessages.length === 0 && (
              <span className="ticker-item">No flash news available right now.</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashNews;